module.exports = __webpack_public_path__ + "static/img/wavm8s-020-glimji-hideout.d0b5213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-020-glimji-hideout.png
// module id = IyMW
// module chunks = 0